/* eslint-disable import/no-cycle */
import store from '@/store'

export default function usePermission() {
  const getUserPermission = value => {
    if (Array.isArray(value)) {
      const isPermissionExist = value.some(item => store.state.auth.userData.permissions.includes(item))
      return isPermissionExist
    }
    return store.state.auth.userData.permissions.includes(value)
  }

  return {
    getUserPermission,
  }
}
